module.exports = __webpack_public_path__ + "static/media/Archane.1a4f1389.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Archane.otf
// module id = 3013
// module chunks = 68